import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import stylePlaceholders from '../../styles/placeholders';
import BaseCaption from '../Card/Caption';
import Price from './Price';
import { ribbonType, colourThemeType } from '../../propTypes';
import theme, { sliceColourTheme } from '../../styles/theme';

const Caption = ({
  brand, classes, className, price, ribbon, specialPrice, sku, title, colourTheme, brandTag,
}) => {
  const ready = !!sku;
  return (
    <BaseCaption
      classNames={{
        caption: cn(className, classes.caption, !sku && classes.placeholder),
        title: classes.brand,
        copy: classes.title,
      }}
      title={ready ? brand : ' '} // need to pass a non-falsy title when rendering placeholders
      copy={ready ? title : ' '}
      colourTheme={colourTheme}
      titleTag={brandTag}
    >
      <Price className={classes.price} price={price} ribbon={ribbon} specialPrice={specialPrice}>
        {price && `$${price}`}
      </Price>
    </BaseCaption>
  );
};

export const captionPropTypes = {
  brand: PropTypes.string,
  price: PropTypes.number,
  ribbon: ribbonType,
  sku: PropTypes.string,
  specialPrice: PropTypes.number,
  title: PropTypes.string,
  sliceType: PropTypes.string,
  brandTag: PropTypes.string,
};

Caption.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  ...captionPropTypes,
  colourTheme: colourThemeType,
};

export const captionDefaultProps = {
  brand: undefined,
  price: undefined,
  ribbon: undefined,
  sku: undefined,
  specialPrice: undefined,
  title: undefined,
  sliceType: undefined,
  brandTag: undefined,
};

Caption.defaultProps = {
  className: undefined,
  ...captionDefaultProps,
  colourTheme: sliceColourTheme.white,
};

export default injectSheet({
  caption: {
    position: 'relative',
  },
  brand: {
    '&&': {
      fontFamily: theme.fonts.bold,
      fontWeight: theme.fonts.boldWeight,
      textTransform: 'none',
      fontSize: 14,
      lineHeight: '20px',
      marginBottom: 4,
      marginRight: 24, // to make space for the wishlist toggle button
    },
  },
  title: {
    fontSize: 14,
    lineHeight: '20px',
    margin: [0, 0, 4],
  },
  price: {
    extend: 'title',
    fontWeight: '600',
    color: ({ colourTheme: { textColour } }) => textColour,
  },
  ...stylePlaceholders({
    brand: { dark: true, text: true, width: '5.5em' },
    title: { text: true, width: '80%' },
    price: { dark: true, text: true, width: '3.3em' },
  }),
})(Caption);
